import { TAddressType } from "../types/address.types";

export const addressTitles: Record<TAddressType, string> = {
  legal: "Юридический адрес",
  postal: "Почтовый адрес",
  postal_additional: "Дополнительный адрес для конвертов",
};
